/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line


  if (window.boostSDAppConfig) {

  window.boostSDAppConfig.integration =  Object.assign({
  
  wishlists: 'growave'
  
  }, window.boostSDAppConfig.integration || {});
  
  }


  let header = document.querySelector('.header__wrapper');
  let largeurExterieureFenetre = window.outerWidth;

  if( window.outerWidth > 1024){
    header.addEventListener('mouseover', function(){
      header.classList.add('meganav--visible');
    })
    header.addEventListener('mouseout', function(){
      header.classList.remove('meganav--visible');
    })
  }
  


  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
